(function () {
  'use strict';

  angular.module('app').service('BillModalService', BillModalService);

  BillModalService.$inject = ['ModalService'];

  function BillModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openSendBillToProvider: openSendBillToProvider,
    };

    return service;

    ////////////////////////

    // Modal bill send email
    function openSendBillToProvider(providerEmail, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/bills/modals/send-bill-to-provider-modal.html',
        controller: BillSendEmailCtrl,
        controllerAs: 'vm',
        inputs: {
          providerEmail: providerEmail,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      BillSendEmailCtrl.$inject = ['$element', 'providerEmail', 'successCallback'];
    }

    function BillSendEmailCtrl($element, providerEmail, successCallback) {
      var vm = this;

      vm.providerEmail = providerEmail;

      vm.sendBill = sendBill;

      function sendBill(isFormValid) {
        if (!isFormValid) {
          vm.serverErrors = [];
          vm.formErrors = true;
        } else {
          vm.sendingForm = true;

          $element.modal('hide');
          successCallback(vm.providerEmail);
        }
      }
    }
  }
})();
